module.exports = __webpack_public_path__ + "img/PE.3a3b530a.svg";